import { MediaStreamConnector } from './MediaStreamConnector';

export type ConnectionStatus = {
    publishing: boolean;
}

export type ConnectionStatusListener = (status: ConnectionStatus) => void;

export interface StatusObservableConnector extends MediaStreamConnector {
    addStatusListener(listener: ConnectionStatusListener): void;
    removeStatusListener(listener: ConnectionStatusListener): void;
}

export function isStatusObservable(connector: MediaStreamConnector): connector is StatusObservableConnector {
    return 'addStatusListener' in connector;
}
